export const IdeaFeed = (() => {
	'use strict';

	let postsContainer;
	let block;

	function init() {
		block = document.querySelector('.pxblock--idea-feed');

		if(!block) return;

		postsContainer = document.querySelector('ul.ideas');
		
		if(block.classList.contains('is-admin')) return;

		fetchPosts();
		window.addEventListener('scroll', handleScroll);
	}

	function handleScroll() {
		const blockRect = block.getBoundingClientRect();
		const blockBottom = blockRect.bottom;

		if (blockBottom <= window.innerHeight) {
			showMorePosts();
		}
	}

	function showMorePosts() {
		const hiddenPosts = document.querySelectorAll('li.hidden');

		if(hiddenPosts.length){
			const hiddenPostsArray = Array.from(hiddenPosts);
			const firstFourHiddenPosts = hiddenPostsArray.slice(0, 4);

			firstFourHiddenPosts.forEach(post => {
				post.classList.remove('hidden');
			});	
		}
	}

	function fetchPosts(){
		fetch(ajaxurl, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
			},
			body: new URLSearchParams({
				action: 'px_fetch_posts',
				post_type: 'post',
				offset: 7,
			})
		})
		.then(response => response.json())
		.then(posts => {
			renderPosts(posts);
			handleScroll();
		})
		.catch(error => console.error('Error:', error));
	}

	function renderPosts(posts){
		let postsHTML = ``;
		
		if(posts.length < 1) return;

		posts.forEach(post => {
			postsHTML += `
				<li class="idea-post hidden">
					<div class="idea--image"> 
						<a href="${post.link}" aria-label="Read ${post.post_title}">
							${post.image}
						</a>
					</div>
					<div class="idea--title">
						<a href="${post.link}" aria-label="Read ${post.post_title}">
							<h3>${post.post_title}</h3>
						</a>
					</div>
					<a href="${post.link}" class="wavy-link" aria-label="Read ${post.post_title}">
						Read More
					</a>
				</li>
			`;
		});

		postsContainer.innerHTML += postsHTML;
	}
	
	return {
		init: init,
		name: 'idea-feed'
	};
})();
